module.exports = __webpack_public_path__ + "static/media/дом ени.f3af1e31.jpg";